// Storage
export const ADD_CONTENT_MODULES = 'ADD_CONTENT_MODULES'
export const ADD_IMAGE_BLUEPRINTS = 'ADD_IMAGE_BLUEPRINTS'
export const ADD_IMAGE_FLAVORS = 'ADD_IMAGE_FLAVORS'
export const ADD_IMAGE_GROUPS = 'ADD_IMAGE_GROUPS'
export const ADD_IMAGE_SNAPSHOTS = 'ADD_IMAGE_SNAPSHOTS'
export const CLEAR_IMAGE_SNAPSHOTS = 'CLEAR_IMAGE_SNAPSHOTS'
export const ADD_IMAGE_TIERS = 'ADD_IMAGE_TIERS'
export const ADD_INFRASTRUCTURE_INSTANCES = 'ADD_INFRASTRUCTURE_INSTANCES'
export const ADD_INFRASTRUCTURE_PODS = 'ADD_INFRASTRUCTURE_PODS'
export const ADD_RESERVATION_TRANSACTION = 'ADD_RESERVATION_TRANSACTION'
export const ADD_RESERVATION_TRANSACTIONS = 'ADD_RESERVATION_TRANSACTIONS'
export const ADD_RESERVATION_INSTANCES = 'ADD_RESERVATION_INSTANCES'
export const ADD_RESERVATION_SAVES = 'ADD_RESERVATION_SAVES'
export const CLEAR_RESERVATION_SAVES = 'CLEAR_RESERVATION_SAVES'
export const ADD_TOPOLOGY_BLUEPRINT = 'ADD_TOPOLOGY_BLUEPRINT'
export const ADD_TOPOLOGY_BLUEPRINTS = 'ADD_TOPOLOGY_BLUEPRINTS'
export const ADD_TOPOLOGY_CATEGORY = 'ADD_TOPOLOGY_CATEGORY'
export const ADD_TOPOLOGY_GROUPS = 'ADD_TOPOLOGY_GROUPS'
export const ADD_TOPOLOGY_IMAGES = 'ADD_TOPOLOGY_IMAGES'
export const ADD_TOPOLOGY_LOCATIONS = 'ADD_TOPOLOGY_LOCATIONS'
// SET STORE VALUES
export const SET_CURRENT_RESERVATION = 'SET_CURRENT_RESERVATION'
export const SET_RESERVATION_IS_EXPIRING = 'SET_RESERVATION_IS_EXPIRING'
export const SET_RESERVATION_IS_TERMINATING = 'SET_RESERVATION_IS_TERMINATING'
export const SET_RESERVATION_IS_VISIBLE = 'SET_RESERVATION_IS_VISIBLE'
export const SET_TOPOLOGY_EDITOR_ID = 'SET_TOPOLOGY_EDITOR_ID'
export const SET_TOPOLOGY_BLUEPRINT_ATTRIBUTES = 'SET_TOPOLOGY_BLUEPRINT_ATTRIBUTES'
export const CLEAR_TOPOLOGY_RELATIONSHIPS = 'CLEAR_TOPOLOGY_RELATIONSHIPS'
